/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import {FC} from 'react'
import {Routes, Route, BrowserRouter, Navigate} from 'react-router-dom'
import {App} from '../App'
import { PrivateRoutes } from './PrivateRoutes'
import { AuthPage } from '../modules/auth/AuthPage'
import { Logout } from '../modules/auth/Logout'
import InternalServerError from '../pages/errorpage/InternalServerError'
import Undermaintain from '../pages/errorpage/Undermantain'
import UpdatePassword from '../modules/auth/components/UpdatePassword'
import { useAuth } from '../modules/auth'

/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
const {PUBLIC_URL} = process.env

const AppRoutes: FC = () => {
  const { currentUser } = useAuth()
  return (
    <BrowserRouter basename={PUBLIC_URL}>
      <Routes>
        <Route element={<App />}>
          <Route path='logout' element={<Logout />} />
          <Route path='500' element={<InternalServerError />} />
          <Route path='501' element={<Undermaintain />} />
          {currentUser ? (
            <>
              {currentUser?.status === 'new' ? (
                <Route path='/*' element={<UpdatePassword />} />
              ) : (
                <> 
                  <Route path='/*' element={<PrivateRoutes />} />
                  <Route index element={<Navigate to='/dashboard' />} />
                </>
              )}
            </>
          ) : (
            <>
              <Route path='auth/*' element={<AuthPage />} />
              <Route path='*' element={<Navigate to='/auth' />} />
            </>
          )}
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export {AppRoutes}
